<template>
  <div style="padding: 0 20px; background: #fff">
    <a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">
      <a-tab-pane v-for="(item, index) in tabList" :key="item.key" :tab="item.tab">
        <SchemeCard
          ref="schemeCardRef"
          :activeKey="item.key"
          :actionUrl="item.url"
          :keysFormArr="item?.keysFormArr || []"
          :gradeDictCode="item?.gradeDictCode"
          :cateDictCode="item?.cateDictCode"
        />
      </a-tab-pane>
      <a-button type="primary" slot="tabBarExtraContent" @click="createLeague">创建</a-button>
    </a-tabs>
  </div>
</template>
<script>
import SchemeCard from '@/comUi/SchemeCard/components/SchemeCard.vue'

const keysFormArr = [
  'title',
  'classify',
  'applicableGrade',
  'cover',
  'courseDesc',
  'file',
  'content',
]

export default {
  name: 'PsychologyCourse',
  components: {
    SchemeCard,
  },
  data() {
    return {
      activeKey: '1',
      tabList: [
        {
          tab: '心理课程',
          key: '1',
          url: 'resourceCource',
          gradeDictCode: 'course_applicable_grade',
          cateDictCode: 'course_sort',
          keysFormArr: [...keysFormArr],
        },
        {
          tab: '团体课程',
          key: '2',
          url: 'resourceCource',
          gradeDictCode: 'course_applicable_grade',
          cateDictCode: 'course_sort',
          keysFormArr: [...keysFormArr],
        },
      ],
    }
  },
  created() {
    const backKey = this.$router.history.current.query.activeKey
    if (backKey) {
      this.activeKey = backKey
    }
  },
  methods: {
    changeTab(key) {
      this.activeKey = key
    },
    createLeague() {
      this.$refs.schemeCardRef[0].showCardModal()
    },
  },
}
</script>
